module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-rc.4-223.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.2.1-rc.4.md
// module id = 666
// module chunks = 321